import { render, staticRenderFns } from "./OutboundConnectorsTable.vue?vue&type=template&id=89f28f1e&"
import script from "./OutboundConnectorsTable.vue?vue&type=script&lang=ts&"
export * from "./OutboundConnectorsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports